import React, { useState } from "react";
import { Card, Typography, List, Space, Button, Input, Popconfirm, Tag, message } from "antd";
import { LinkOutlined, DeleteOutlined, EditOutlined, CloseCircleOutlined, CheckOutlined, CloseOutlined, FileTextOutlined } from "@ant-design/icons";

const { Text } = Typography;

/**
 * 文件关联组卡片组件
 * 用于展示和管理单个文件关联组
 */
const FileGroupCard = ({ group, files, onRemoveMember, onDisbandGroup, onEditName, isSubmitting = false }) => {
    const [isEditingName, setIsEditingName] = useState(false);
    const [editingName, setEditingName] = useState(group.name || "");

    // 获取组内文件列表
    const groupFiles = files.filter((file) => group.memberKeys.includes(file.storage_path));

    // 处理组名保存
    const handleSaveName = () => {
        const trimmedName = editingName.trim();
        if (trimmedName.length > 200) {
            message.warning("组名最多200个字符");
            return;
        }
        onEditName(group.id, trimmedName);
        setIsEditingName(false);
    };

    // 取消编辑
    const handleCancelEdit = () => {
        setEditingName(group.name || "");
        setIsEditingName(false);
    };

    // 获取文件图标
    const getFileIcon = (fileName) => {
        const ext = fileName.split(".").pop().toLowerCase();
        if (["pdf"].includes(ext)) return <FileTextOutlined style={{ color: "#f40" }} />;
        if (["jpg", "jpeg", "png"].includes(ext)) return <FileTextOutlined style={{ color: "#52c41a" }} />;
        if (["xls", "xlsx"].includes(ext)) return <FileTextOutlined style={{ color: "#1890ff" }} />;
        return <FileTextOutlined />;
    };

    return (
        <Card
            size="small"
            style={{
                marginBottom: 16,
                border: "1px solid #1890ff",
                backgroundColor: "#f0f8ff",
            }}
            title={
                <Space>
                    <LinkOutlined style={{ color: "#1890ff" }} />
                    {isEditingName ? (
                        <Space size="small">
                            <Input
                                size="small"
                                value={editingName}
                                onChange={(e) => setEditingName(e.target.value)}
                                placeholder="输入组名（可选）"
                                style={{ width: 200 }}
                                maxLength={200}
                                onPressEnter={handleSaveName}
                                autoFocus
                            />
                            <Button type="link" size="small" icon={<CheckOutlined />} onClick={handleSaveName} disabled={isSubmitting}>
                                保存
                            </Button>
                            <Button type="link" size="small" icon={<CloseOutlined />} onClick={handleCancelEdit} disabled={isSubmitting}>
                                取消
                            </Button>
                        </Space>
                    ) : (
                        <Space size="small">
                            <Text strong>{group.name || `文件组 ${group.id.slice(0, 8)}`}</Text>
                            <Button type="link" size="small" icon={<EditOutlined />} onClick={() => setIsEditingName(true)} disabled={isSubmitting}>
                                编辑
                            </Button>
                        </Space>
                    )}
                    <Tag color="blue">{groupFiles.length} 个文件</Tag>
                </Space>
            }
            extra={
                <Popconfirm title="确定要解散此关联组吗？文件将保留，但关联关系会被移除。" onConfirm={() => onDisbandGroup(group.id)} okText="确定" cancelText="取消" disabled={isSubmitting}>
                    <Button type="text" size="small" danger icon={<CloseCircleOutlined />} disabled={isSubmitting}>
                        解散关联组
                    </Button>
                </Popconfirm>
            }
        >
            <List
                size="small"
                dataSource={groupFiles}
                renderItem={(file) => (
                    <List.Item
                        actions={[
                            <Popconfirm title="确定要从关联组移除此文件吗？" onConfirm={() => onRemoveMember(group.id, file.storage_path)} okText="确定" cancelText="取消" disabled={isSubmitting}>
                                <Button type="text" size="small" danger icon={<DeleteOutlined />} disabled={isSubmitting}>
                                    移除
                                </Button>
                            </Popconfirm>,
                        ]}
                    >
                        <List.Item.Meta
                            avatar={getFileIcon(file.filename)}
                            title={<Text>{file.filename}</Text>}
                            description={
                                <Space>
                                    <Text type="secondary">{(file.file_size / 1024 / 1024).toFixed(2)} MB</Text>
                                </Space>
                            }
                        />
                    </List.Item>
                )}
            />
        </Card>
    );
};

export default FileGroupCard;


